<template>
    <Vue2DateRangePicker
            :startDate="start"
            :endDate="end"
            @update="value => {
                this.$emit('update', value);

                this.start = value.startDate;
                this.end = value.endDate;
            }"
            :locale-data="locale"
            :opens="opens"
            :autoApply="autoApply"
            :ranges="ranges"
    >
        <!--Optional scope for the input displaying the dates -->
        <div slot="input">
            <slot name="input">
                <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-chevron-down" icon-after>{{ rangeText }}</vs-button>
            </slot>
        </div>
    </Vue2DateRangePicker>
</template>

<script>
    import Vue2DateRangePicker from 'vue2-daterange-picker';
    import {moment} from "../helpers/utils";

    export default {
        name: "DateRangePicker",
        components: { Vue2DateRangePicker },
        props: {
            startDate: {
                type: [Object, Date],
                default: function () {
                    return moment();
                }
            },
            endDate: {
                type: [Object, Date],
                default: function () {
                    return moment();
                }
            },
            autoApply: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                start: moment(),
                end: moment(),
                opens: "left",//which way the picker opens, default "center", can be "left"/"right"
                locale: {
                    direction: 'ltr', //direction of text
                    format: 'DD/MM/YYYY', //fomart of the dates displayed
                    separator: ' - ', //separator between the two ranges
                    applyLabel: 'Buscar',
                    cancelLabel: 'Cancelar',
                    weekLabel: 'W',
                    customRangeLabel: 'Definir data',
                    daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
                    monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
                    firstDay: 1, //ISO first day of week - see moment documenations for details
                    showWeekNumbers: true //show week numbers on each row of the calendar
                },
                ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
                    'Hoje': [moment(), moment()],
                    'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                    'Mês Anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'Este Ano': [moment().startOf('year'), moment().endOf('year')],
                }
            }
        },
        created() {
            this.start = this.startDate;
            this.end = this.endDate;
        },
        watch: {
            startDate(val) {
                this.start = val;
            },
            endDate(val) {
                this.end = val;
            }
        },
        computed: {
            startText () {
                return moment(this.start).format(this.locale.format)
            },
            endText () {
                return moment(this.end).format(this.locale.format)
            },
            rangeText () {
                const ranges = this.ranges;
                const textRange = Object.keys(ranges).find(element => {
                    return moment(ranges[element][0]).isSame(this.start, 'day') && moment(ranges[element][1]).isSame(this.end, 'day')
                });
                if (textRange) {
                    return textRange;
                }
                let range = this.startText;
                if (!this.singleDatePicker) {
                    range += this.locale.separator + this.endText;
                }
                return range;
            },
        }
    }
</script>

<style scoped>

</style>
